import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

const check = (response) => ResponseChecker(defaultMessages, response);

export const GetAll = async (option) =>
  check(await $api.get(Endpoints.DiscountRule.GetAll(option)));
export const Create = async (form) =>
  check(await $api.post(Endpoints.DiscountRule.Create(), form));
export const Update = async (form, option) =>
  check(await $api.put(Endpoints.DiscountRule.Update(option), form));
export const UpdateActive = async (form, option) =>
  check(await $api.put(Endpoints.DiscountRule.UpdateActive(option), form));
export const Delete = async (option) =>
  check(await $api.delete(Endpoints.DiscountRule.Delete(option)));

export default { GetAll, Create, Update, UpdateActive, Delete };
